import * as Sentry from "@sentry/react";
import { CaptureContext, SeverityLevel } from "@sentry/core";

/**
 * Reports a message to sentry. Does not require an error.
 * @param message Message to report
 * @param level severity level of the message, defaults to info
 * @param extra extra data to send to sentry
 * @example reportMessageToSentry("Something bad is happening, but we can recover", null, "warning");
 * @example reportMessageToSentry("We did a thing!", { someKey: "someValue" }, "log");
 * @example reportMessageToSentry("This is a sample message");
 */
export async function reportMessageToSentry(
  message: string,
  extra: Omit<CaptureContext, "level">,
  level: SeverityLevel = "info"
) {
  Sentry.captureMessage(message, { level, extra });
  return Sentry.flush(2000);
}
